module.exports = __webpack_public_path__ + "img/background.db322ec1.png";